import { createRepile } from "repilejs";

const { getValue, next } = createRepile({
  state: {
    name: "Varun Bardwaj",
  },
});

export { getValue as user, next as updateUser };
